import { useEffect } from "react";

export function useDedupEffect(fn: React.EffectCallback, dependencies: React.DependencyList) {
    useEffect(() => {
       let hasExecuted = false;
       if (!hasExecuted) {
         fn();
       }
       return () => {
         hasExecuted = true;
       };
    }, dependencies);
    }